<template>
  <div
    class="product-stock has-promotion-stock"
  >
    <div class="promotion">
      <div class="lightBlue pointer promotion-tip">
        <button
          type="button"
          class="tooltip-btn"
          @click="showPromotion"
        >
          프로모션 내용
        </button>
      </div>
      <div
        class="promotion-tip-alert"
        :style="promotionStyle"
      >
        <div class="txt-wrap">
          <p>아티스트리 워터 에센스 선 프로텍트</p>
          <p>SPF50+ PA++++ 2개 구매 시, 아티스트리 워터</p>
          <p>에센스 선 프로텍트 미니 1개 증정</p>
        </div>
        <div class="txt-btn-detail">
          <a href="#"><span>프로모션 상세보기</span></a>
        </div>
        <div class="tip-close">
          <button
            type="button"
            class="tooltip-closed"
            @click="showPromotion"
          >
            창닫기
          </button>
        </div>
      </div>
    </div>
    <div class="cartlist-instock">
      <span class="green">
        <a href="#">
          <span class="icon icon-check-bold" />
          <span class="text text-uppercase">적용</span>
        </a>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromotionTooltipInfo',
  data() {
    return {
      promotionStyle: 'display: none',
    };
  },
  methods: {
    showPromotion() {
      this.promotionStyle = this.promotionStyle === 'display: none' ? 'display: block' : 'display: none';
    },
  },
};
</script>

<style>

</style>
